<script setup lang="ts">
import { WhoWeAreProps } from "./WhoWeAre.props"
const { content, page } = defineProps<WhoWeAreProps>()
</script>

<template>
  <div class="who-we-are">
    <div class="md:grid-standard">
      <CartUtilsLogin
        class="col-span-full py-4 text-center"
        :upperText="$t('loginBanner.type2.upperText')"
        show-login-button
      />
    </div>

    <div class="grid-standard">
      <div class="col-span-full py-6 md:col-span-10 md:col-start-2">
        <p
          v-if="page?.title"
          class="elephant-bold md:mammoth-bold mb-2 md:mb-4"
        >
          {{ page?.title }}
        </p>

        <h1
          v-if="page?.subtitle"
          class="dolphin-bold text-green-main mb-4 md:mb-6"
        >
          {{ page?.subtitle }}
        </h1>

        <UtilsMarkdown
          v-if="page?.content"
          :content="page?.content"
          class="
            markdown__link-underlined
            pig
            markdown__link-green-main markdown__paragraph-margin-bottom-4
          "
          :inline="false"
        />
      </div>
    </div>
    <!-- TODO: Prodotti scontati più del 50% RAILS NON esiste nel DS -->
    <DynamicContent
      v-if="!!content"
      class="cms-content"
      :components="content"
    />
  </div>
</template>
